import { Button, Image } from 'antd';
import jsPDF from 'jspdf';
import xlsx from 'xlsx';
import { applyPlugin } from 'jspdf-autotable';
import React from 'react';
import EXCEL_ICON from './assets/excel.svg'
import PDF_ICON from './assets/pdf.svg'
applyPlugin(jsPDF);

interface IButtonExports {
  dataSource: any[],
  columns: any[],
  sheetName?: string,
  paperSheetSizePdf?: any,
  exportOptions?: ExportOption,
  multiSheetData?: MultiSheetData[]
}

export interface ExportOption {
  showExcel: boolean,
  showPDF: boolean,
  allowExport: boolean
}

export interface MultiSheetData {
  sheetName: string,
  data: any[],
  columns: any[]
}

const ButtonExport: React.FC<IButtonExports> = ({
  columns, dataSource, sheetName = 'REPORTE', exportOptions = {
    allowExport: true,
    showExcel: true,
    showPDF: true
  }, paperSheetSizePdf = 'legal', multiSheetData
}) => {

  const GenerateExcel = () => {
    const workbook = xlsx.utils.book_new();

    // Si se proporciona `multiSheetData`, genera múltiples hojas
    if (multiSheetData && multiSheetData.length > 0) {
      multiSheetData.forEach(sheet => {
        const dataToExport = sheet.data.map((dat: any) => {
          const obj: any = {};
          sheet.columns.forEach((col: any) => {
            obj[col.title] = dat[col.dataIndex];
          });
          return obj;
        });

        const worksheet = xlsx.utils.json_to_sheet(dataToExport);
        xlsx.utils.book_append_sheet(workbook, worksheet, sheet.sheetName);
      });
    } else {
      // De lo contrario, genera una sola hoja
      const dataToExport = dataSource.map((dat: any) => {
        const obj: any = {};
        columns.forEach((col: any) => {
          obj[col.title] = dat[col.dataIndex];
        });
        return obj;
      });

      const worksheet = xlsx.utils.json_to_sheet(dataToExport);
      xlsx.utils.book_append_sheet(workbook, worksheet, sheetName);
    }

    const excelBuffer = xlsx.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    saveAsExcelFile(excelBuffer, sheetName);
  };

  const saveAsExcelFile = (buffer: Buffer, fileName: string): void => {
    import('file-saver').then(FileSaver => {
      const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  };

  const textoCentrado = (doc: any, text: string, alto: number): any => {
    const textWidth = (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
    const textOffset = (doc.internal.pageSize.width - textWidth) / 2;
    return doc.text(textOffset, alto, text);
  };

  const exportPdf = (): void => {
    const doc: any = new jsPDF('l', 'pt', paperSheetSizePdf);
    doc.setFontSize(14);
    textoCentrado(doc, sheetName, 20);
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(10);
    doc.autoTable({
      startY: 50,
      body: dataSource,
      columns: columns.map(columna => ({
        header: columna.title,
        dataKey: columna.dataIndex
      })),
      styles: { fontSize: 9 },
      headStyles: { fillColor: [145, 145, 145], fontStyle: 'normal' }
    });
    doc.save(sheetName + '.pdf');
  };

  return (
    <>
      {exportOptions.allowExport ? <div style={{
        display: 'flex',
        gap: '1rem'
      }}>
        {exportOptions.showPDF && <Button style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor:'#FFDDDB',
          border:'none',
          
        }} onClick={exportPdf}>
          <Image src={PDF_ICON} height={20} preview={false} />
        </Button>}
        {exportOptions.showExcel && <Button style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor:'#D9F9EA',
          border:'none',
            


        }} onClick={GenerateExcel}>
          <Image  height={20} src={EXCEL_ICON} preview={false} />

        </Button>}
      </div>:<div />}
    </>
  );
};

export default ButtonExport;
